import * as intl from 'react-intl-universal';
import * as persisStore from 'src/redux/store';
import StorageService from 'src/services/StorageService';
import { LANGUAGE_NAME } from 'src/constants/ActionTypes';

const locales = {
  'zh-hans': require('src/locales/zh-hans.json'),
  'zh-tw': require('src/locales/zh-tw.json'),
  en: require('src/locales/en.json'),
  ja: require('src/locales/ja.json'),
};

interface ISupportLang {
  name: string;
  value: string;
}

export const SUPPORT_LOCALES: ISupportLang[] = [
  {
    name: '简体中文',
    value: 'zh-hans',
  },
  {
    name: '繁体中文',
    value: 'zh-tw',
  },
  {
    name: 'ENGLISH(英文)',
    value: 'en',
  },
  {
    name: '日本語(日文)',
    value: 'ja',
  },
];

/**
 * 翻译service
 * @class I18NService
 */
class I18NService {
  langOption: intl.ReactIntlUniversalOptions;

  /**
   * 初始化多语言环境
   * @returns {Promise<void>}
   * @memberof I18NService
   */
  init(): Promise<void> {
    const currentLocale: string = StorageService.getItem('language') || this.defaultLanguage;
    this.langOption = {
      currentLocale,
      locales,
    };
    StorageService.setItem('language', currentLocale);

    const { store } = persisStore;
    store.dispatch({type: LANGUAGE_NAME, language: currentLocale});

    return intl.init(this.langOption);
  }

  /**
   * 重置多语言环境
   * @param {string} currentLocale
   * @returns {Promise<void>}
   * @memberof I18NService
   */
  reset(currentLocale: string): Promise<void> {
    this.langOption = {
      currentLocale,
      locales,
    };
    StorageService.setItem('language', currentLocale);

    const { store } = persisStore;
    store.dispatch({type: LANGUAGE_NAME, language: currentLocale});
    
    return intl.init(this.langOption);
  }

  /**
   * 获取key对应的翻译内容
   *
   * @param {(string | undefined)} key
   * @param {boolean} [spaceAfter] 译文之后是否需要空格，默认不需要空格
   * @returns {string}
   * @memberof I18NService
   */
  get(key: string | undefined, spaceAfter?: boolean): string {
    if (!!key) {
      if (spaceAfter === true) {
        return `${intl.get(key).defaultMessage('not_exist_key')} `;
      } else if (spaceAfter === false) {
        return intl.get(key).defaultMessage('not_exist_key');
      } else {
        if (!!this.langOption && this.langOption.currentLocale !== 'zh-hans' && this.langOption.currentLocale !== 'zh-tw') {
          // 非中文环境翻译自动添加空格
          return ` ${intl.get(key).defaultMessage('not_exist_key')}`;
        } else {
          return intl.get(key).defaultMessage('not_exist_key');
        }
      }
    } else {
      return 'key_is_null';
    }
  }

  /**
   * 默认语言code
   *
   * @returns {string}
   * @memberof I18NService
   */
  get defaultLanguage(): string {
    return SUPPORT_LOCALES[0].value;
  }

  /**
   * 强制设置成默认语言（中文简体）
   *
   * @returns {Promise<void>}
   * @memberof I18NService
   */
  async forceDefault(): Promise<void> {
    if (!!this.langOption && this.langOption.currentLocale !== this.defaultLanguage) {
      await this.reset(this.defaultLanguage);
    }
  }
}

export default new I18NService();



// WEBPACK FOOTER //
// ./src/services/I18NService.ts